import {LeftOutlined} from '@ant-design/icons';

type ChangeVendorButtonProps = {
  title: string;
  onClick: () => void;
};

const ChangeVendorButton: React.FC<ChangeVendorButtonProps> = ({title, onClick}) => {
  return (
    <button
      type="button"
      className="relative w-full cursor-pointer overflow-hidden rounded-xl bg-blue-mist p-3 text-start"
      onClick={onClick}
    >
      <span className="relative z-10 flex items-center justify-between gap-3 py-1">
        <span className="truncate text-body-sm-emphasis text-gray-09">{title}</span>
        <span className="flex shrink-0 gap-2 items-center text-subtitle-xs text-gray-08">
          تغییر فروشگاه
          <LeftOutlined aria-hidden />
        </span>
      </span>
      <span className="absolute -end-5 top-1/2 size-20 rounded-full border border-white/35 bg-linear-to-br from-white/40 to-white/0 opacity-20 backdrop-blur-sm" />
      <span className="absolute -start-17 top-1/2 size-42.5 -translate-y-1/2 rounded-full border border-white/35 bg-linear-to-br from-white/40 to-white/0 opacity-20 backdrop-blur-sm" />
    </button>
  );
};

export default ChangeVendorButton;
